import { Sparkles } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

import { paths } from '@/app/paths';
import ThemeToggle from '@/components/ThemeToggle';
import { useStore } from '@/store/AppStore';

import GlobalSearch from './GlobalSearch';
import NotificationsMenu from './NotificationsMenu';
import { type PageHeaderStore, usePageHeaderValue } from './pageHeader';
import UserMenu from './UserMenu';

/** Cabeçalho fixo: trilha, título e subtítulo da página, busca, tema, notificações e usuário. */
export default function Header({ store, onLogout }: { store: PageHeaderStore; onLogout: () => void }) {
  const header = usePageHeaderValue(store);
  const { permissions } = useStore();
  const { pathname } = useLocation();
  const showGenerate = permissions.generate && pathname !== paths.generate;

  return (
    <header
      data-app-header
      className="sticky top-0 z-30 flex min-h-17 items-center gap-2.5 bg-page/92 px-4 py-2.5 backdrop-blur-sm md:px-7"
    >
      <div className="flex min-w-0 flex-1 flex-col justify-center">
        {header.crumb ? (
          <nav aria-label="Trilha" className="flex gap-1.5 text-meta leading-tight text-ink-subtle">
            <Link to={header.crumb.to} className="text-ink-subtle hover:text-primary">
              {header.crumb.label}
            </Link>
            <span aria-hidden>/</span>
            <span className="truncate text-ink-secondary">{header.title}</span>
          </nav>
        ) : null}
        <h1 className="m-0 truncate text-heading font-bold">{header.title}</h1>
        {header.subtitle ? (
          <p className="m-0 truncate text-control text-ink-subtle max-md:hidden">{header.subtitle}</p>
        ) : null}
      </div>
      <div className="max-lg:hidden">
        <GlobalSearch />
      </div>
      {showGenerate ? (
        <Link
          to={paths.generate}
          aria-label="Gerar escala"
          title="Gerar escala"
          className="grid size-10 place-items-center rounded-control bg-primary text-white hover:bg-primary-hover hover:text-white md:hidden"
        >
          <Sparkles aria-hidden className="size-4 stroke-[1.8]" />
        </Link>
      ) : null}
      <ThemeToggle className="max-md:hidden" />
      <NotificationsMenu />
      <UserMenu onLogout={onLogout} />
    </header>
  );
}
